import { render, staticRenderFns } from "./cpt-change-lang.vue?vue&type=template&id=63e10b82&scoped=true"
import script from "./cpt-change-lang.vue?vue&type=script&lang=js"
export * from "./cpt-change-lang.vue?vue&type=script&lang=js"
import style0 from "./cpt-change-lang.vue?vue&type=style&index=0&id=63e10b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e10b82",
  null
  
)

export default component.exports